// extracted by mini-css-extract-plugin
export var fadeInOut = "_4d-3";
export var icon = "_4d-4";
export var savedIndicator = "_4d-2";
export var savingIndicator = "_4d-0";
export var spin = "_4d-1";